import ThemeCtx from "@/src/contexts/ThemeCtx"
import { useContext } from "react"

const useTheme = () => {
  return useContext(ThemeCtx)
}

export default useTheme
